import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { Comment, Reply } from '@/models/registry';
import dayjs from 'dayjs';
import UserProfileCard from '../../deal/activity-feed/user-profile-card';

const TIMESTAMP_FORMAT = 'MMM D, YYYY hh:mma';

const CommentReplyHeader = ({
  commentOrReply,
  isEditingComment,
}: {
  commentOrReply: Comment | Reply;
  isEditingComment: boolean;
}) => {
  const { created_by, created_at, edited, updated_at } = commentOrReply;

  return (
    <div className="flex flex-row gap-2 items-center flex-wrap">
      <div className="text-xs  text-black">
        {created_by && <UserProfileCard user={created_by} withAvatar />}
      </div>
      <Tooltip>
        <TooltipTrigger>
          <div className="text-xs  text-gray-500 text-nowrap">
            {dayjs(created_at).fromNow()}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {dayjs(created_at).format(TIMESTAMP_FORMAT)}
        </TooltipContent>
      </Tooltip>
      {edited && !isEditingComment && (
        <Tooltip>
          <TooltipTrigger>
            <div className="text-xs  text-gray-500 text-nowrap">(edited)</div>
          </TooltipTrigger>
          <TooltipContent>
            {dayjs(updated_at).format(TIMESTAMP_FORMAT)}
          </TooltipContent>
        </Tooltip>
      )}
      {isEditingComment && (
        <div className="text-xs  text-gray-500 text-nowrap">(editing)</div>
      )}
    </div>
  );
};

export default CommentReplyHeader;
